import callAPI from "@helpers/network";
import forgotPasswordAPIServices from "@services/forgot-password";

export const FORGOT_PASSWORD_SERVICES = {
  POST_SEND_OTP: async (
    param: { type: string; identifier: string; generateToken?: string },
    language: string,
  ) => {
    return callAPI(forgotPasswordAPIServices.POSTSendOTPService(param, language), true);
  },
  POST_VERIFY_OTP: async (
    param: { identifier: string; otp: string | undefined; signatureCode: string },
    token: string,
    language: string,
  ) => {
    return callAPI(forgotPasswordAPIServices.POSTVerifyOTPService(param, token, language), true);
  },
  PUT_RESET_PASSWORD: async (
    param: {
      identifier: string;
      otp: string;
      signatureCode: string;
      newPassword?: string;
      reEnterNewPassword?: string;
    },
    token: string,
    language: string,
  ) => {
    return callAPI(forgotPasswordAPIServices.PUTResetPasswordService(param, token, language), true);
  },
};
